<template>
  <b-card>

    <Breadcrumb title="Inventario - Crear sección" link="/inventory/sections" />

    <FormCreateSection action="CREATE" :dangers="casDangers" @on-btn-ok="onHandleBtnOK" />

  </b-card>
</template>

<script>

// Componentes
import Breadcrumb from '../components/Breadcrumb.vue'
import FormCreateSection from '../components/sections/Form.vue'

// Mixins
import FormMixin from "../../../servicios/inventory/mixins/sections/form"

export default {

  name: 'InventorySectionsRegister',

  components: {
    Breadcrumb,
    FormCreateSection
  },

  mixins: [FormMixin]

};
</script>
